const themeFonts = {};

export default themeFonts;
